import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, message } from "antd";

import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";

export default function ExportExcel({
  columnsData,
  rowsData,
  filename,
  loading,
  disabled,
  colWidth,
  ...props
}) {
  const [dataSet, setDataSet] = useState([]);

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

  const borderStyle = {
    top: { style: "thin", color: { rgb: "A29300" } },
    bottom: { style: "thin", color: { rgb: "A29300" } },
    left: { style: "thin", color: { rgb: "A29300" } },
    right: { style: "thin", color: { rgb: "A29300" } },
  };

  const titleStyle = {
    font: { sz: "14", bold: true },
    fill: {
      patternType: "solid",
      fgColor: { rgb: "F5EE90" },
    },
    alignment: { horizontal: "center", vertical: "center" },
    border: borderStyle,
  };

  const cellStyle = {
    alignment: { vertical: "center", wrapText: true },
    fill: {
      patternType: "solid",
      fgColor: { rgb: "F1F1F1" },
    },
    border: {
      top: { style: "thin", color: { rgb: "9C9C9C" } },
      bottom: { style: "thin", color: { rgb: "9C9C9C" } },
      left: { style: "thin", color: { rgb: "9C9C9C" } },
      right: { style: "thin", color: { rgb: "9C9C9C" } },
    },
  };

  const title = (title) => ({
    title: title,
    width: { wch: colWidth || 25 },
    style: titleStyle,
  });

  const columnHandler = (columns) => columns.map((column) => title(column));

  useEffect(() => {
    if (rowsData?.length > 0) {
      let exportData = {};
      exportData.columns = columnHandler(columnsData);

      let rows = [];
      rowsData.map((row) => {
        let d = [];
        row.map((r) => {
          d.push({ value: r, style: { ...cellStyle } });
        });
        rows.push(d);
      });

      exportData.data = rows;
      setDataSet([exportData]);
    }
  }, [rowsData]);

  return (
    <ExcelFile
      filename={filename}
      element={
        <Button key="export" loading={loading} disabled={disabled}>
          <FontAwesomeIcon
            icon={["fas", "file-excel"]}
            style={{ marginRight: 8 }}
          />
          Excel'e Aktar
        </Button>
      }
    >
      <ExcelSheet dataSet={dataSet} name={filename} />
    </ExcelFile>
  );
}
